export const INSTANT_VALIDATION_BOUNDARY_NAME =
  '__next_instant_validation_boundary__'
